export default __webpack_public_path__ + "static/media/2c7da4b8026440b0.d13363aedc369e52a5e7f3c83c96e2cc.svg";